const WHY_CHOOSE_STRIPS_ABOVE = 2;

/**
 * Index in the PDP's product strips that Why Choose renders before: after the
 * second strip that has products, so it sits above the third (Digi Merch).
 * Strips without products render nothing, so when Algonomy returns fewer
 * (or hasn't loaded, or is blocked) it moves up, down to the top of the
 * strip area when there are none. Returns `strips.length` for "after them all".
 */
const getWhyChooseStripSlot = (
  strips: { items?: unknown[] | null }[]
): number => {
  let filled = 0;

  for (let i = 0; i < strips.length; i += 1) {
    if (filled === WHY_CHOOSE_STRIPS_ABOVE) return i;
    if (strips[i]?.items?.length) filled += 1;
  }

  return strips.length;
};

export default getWhyChooseStripSlot;
